import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { FormId } from 'constants/formId';
import { ClippingPlatformState } from 'store/clippingPlatformState';
import {
  baseMapDispatchToProps,
  baseMapStateToProps,
  ComponentBase,
  BaseDispatchProps,
  BaseStateProps,
} from 'components/componentBase';
import { AppTextField } from 'components/form/appTextField';
import { required, email } from 'components/form/formValidations';

interface ClientsUserFormComponentOwnProps {
  formId: FormId.ClientsUserAdd | FormId.ClientsUserEdit;
}

type ClientsUserFormComponentStateProps = BaseStateProps;

type ClientsUserFormComponentDispatchProps = BaseDispatchProps;

class ClientsUserFormComponent extends ComponentBase<
  ClientsUserFormComponentOwnProps,
  ClientsUserFormComponentStateProps,
  ClientsUserFormComponentDispatchProps
> {
  protected loggedInRender() {
    return (
      <>
        <AppTextField name="firstName" label="First name" validate={[required]} />
        <AppTextField name="lastName" label="Last name" validate={[required]} />
        <AppTextField name="email" label="Email" validate={[required, email]} />
      </>
    );
  }
}

const mapStateToProps = (state: ClippingPlatformState): ClientsUserFormComponentStateProps =>
  baseMapStateToProps(state);

const mapDispatchToProps = (dispatch: Dispatch): ClientsUserFormComponentDispatchProps =>
  baseMapDispatchToProps(dispatch);

export const ClientsUserForm = connect(mapStateToProps, mapDispatchToProps)(ClientsUserFormComponent);
